'use client'

import Modal from '@/components/Modal/Modal'
import { PricingContent } from '@/components/Pricing/PricingContent'
import { usePricingModal } from '@/hooks/usePricingModal'

const PricingModal: React.FC = () => {
  const { isOpen, setClose: onClose } = usePricingModal()

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative h-[90vh] w-[80vw] overflow-auto rounded-xl bg-white/90 2xl:h-[75vh] 2xl:w-[60vw]">
        {isOpen && (
          <PricingContent
            minimal={true}
            pricingTitle="Upgrade to continue"
            pricingSubtitle="You've hit your account limit. Please upgrade your plan to continue"
          />
        )}
      </div>
    </Modal>
  )
}

export default PricingModal
